export default __webpack_public_path__ + "static/media/4.7c6d5fd9.jpg";